import { createContext, useContext, useRef } from 'react';

export interface ICampaignAdvanceSettingRef {
  waitForPendingSave: () => Promise<void>;
}

interface ICampaignSettingsRefContext {
  settingsRef: React.RefObject<ICampaignAdvanceSettingRef>;
}

const CampaignSettingsRefContext = createContext<ICampaignSettingsRefContext | undefined>(
  undefined,
);

export const CampaignSettingsRefProvider = ({ children }: { children: React.ReactNode }) => {
  const settingsRef = useRef<ICampaignAdvanceSettingRef>(null);

  return (
    <CampaignSettingsRefContext.Provider value={{ settingsRef }}>
      {children}
    </CampaignSettingsRefContext.Provider>
  );
};

export const useCampaignSettingsRefContext = (): ICampaignSettingsRefContext => {
  const context = useContext(CampaignSettingsRefContext);
  if (!context) {
    throw new Error('GEMX_CONTEXT_IS_NOT_DEFINED');
  }
  return context;
};
